export default "__VITE_ASSET__BY0vbi6k__"